<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<!--START OPTIONS-->
					<!--DistrictSchoolID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <select  class="form-control" name="DistrictSchoolID" [(ngModel)]="report.DistrictSchoolID">
                                <option value="" style="display:none;"></option>
                                <option *ngFor="let o of DistrictSchoolList" [ngValue]="o.SchoolID">{{o.SchoolName}}</option>
                            </select> -->

							<caass-schoolselector
								[ShowAll]="true"
								[ShowAllID]="SchoolSelectShowAllID"
								[ShowAllText]="SchoolSelectShowAllText"
								[IsReport]="true"
								[ReportID]="291"
							>
							</caass-schoolselector>
						</div>
					</div>

					<!--StartMonthID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Start Month</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="StartMonthID" [(ngModel)]="report.StartMonthID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of MonthList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--StartYearID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Start Year</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="StartYearID" [(ngModel)]="report.StartYear">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of YearList" [ngValue]="o">
									{{ o }}
								</option>
							</select>
						</div>
					</div>

					<!--EndMonthID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">End Month</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="EndMonthID" [(ngModel)]="report.EndMonthID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of MonthList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--EndYearID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">End Year</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="EndYearID" [(ngModel)]="report.EndYear">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of YearList" [ngValue]="o">
									{{ o }}
								</option>
							</select>
						</div>
					</div>

					<!--ActionType-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Action Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ActionTypeID" [(ngModel)]="report.ActionTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ActionTypeList" [ngValue]="o.ActionTypeID">
									{{ o.ActionTypeDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--SchoolGroupID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School Group</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="SchoolGroupID" [(ngModel)]="report.SchoolGroupID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of SchoolGroupList" [ngValue]="o.SchoolGroupID">
									{{ o.SchoolGroupDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--ImageLogo-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Logo</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="ImageLogo" [(ngModel)]="report.ImageLogo">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of ImageLogoList" [ngValue]="o.ImageLibraryID">
									{{ o.LogoDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--File Type-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Output File Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--Submit Form-->
					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
							{{ errorMessage }}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
							<button name="btnSaving" *ngIf="!isProcessing" class="btn btn-primary" type="button" (click)="Print()">Print</button>
							<button
								name="btnMerge"
								*ngIf="!isProcessing"
								class="btn btn-primary"
								style="margin-left: 5px"
								type="button"
								(click)="MergeToGroup()"
							>
								Merge to Group
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
